export default import.meta.ROLLDOWN_FILE_URL_MUV3v4ngPguySGDMUo_y$w